module.exports = __webpack_public_path__ + "static/media/Heights.bd0124c6.jpg";